import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Shared public site config (admin-controlled launch phase + stock reminder
 * cadence). Defaults to the safe "preparation" phase until the API responds so
 * the pre-launch messaging never flashes the customer-live branch by mistake.
 */
export function useSiteConfig() {
  const [config, setConfig] = useState({
    launch_phase: "preparation",
    stock_reminder_days: 7,
    loaded: false,
  });
  useEffect(() => {
    let active = true;
    api
      .get("/settings/public")
      .then((r) => {
        if (!active) return;
        setConfig({
          launch_phase: r.data?.launch_phase || "preparation",
          stock_reminder_days: r.data?.stock_reminder_days || 7,
          loaded: true,
        });
      })
      .catch(() => active && setConfig((c) => ({ ...c, loaded: true })));
    return () => {
      active = false;
    };
  }, []);
  return config;
}
